import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import IpsDTCommentsDialog from '../../containers/startproj/Comments/IpsDTCommentsDialog';
import { getCommentsIpsDT } from 'api';
import { Badge } from 'antd';

export default withRouter(function IpsDTCommentsIcon(props) {
  const { project, commentGroup ,view ,comments ,phase} = props;

  const [commentsList, setCommentsList] = useState(comments);

  useEffect(() => {
    // check for when making call for dashboard and not making api call when you are inside project

    if (view !== 'dashboard') {
      
      return
    }
   
    async function getCommentsById(projectInfo) {

      const result = await getCommentsIpsDT(projectInfo, commentGroup);

      setCommentsList(result);
    }
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
      phase:phase
    };
    getCommentsById(projectInfo);
  }, []);

  function commentsConfirm(project) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <IpsDTCommentsDialog
            onClose={onClose}
            project={project}
            commentGroup={commentGroup}
            commentsList={commentsList}
            phase={phase}
            setCommentsList={setCommentsList}
          />
        );
      },
    });
  }

  return (
    <span style={{ float: 'right' }}>
      <Badge
        size='small'
        count={commentsList && commentsList.length} 
        showZero={false}
        title={''}
      >
        <FontAwesomeIcon
          id={'cmticon'}
          icon={faCommentDots}
          pull={'right'}
          size='lg'
          style={{ cursor: 'pointer' }}
          onClick={() => commentsConfirm(project)}
        >
          Comment
        </FontAwesomeIcon>
      </Badge>
    </span>
  );
});
